import {Model} from "@vuex-orm/core";
import BeneficiaryAssignment from "./BeneficiaryAssignment";

export default class Asset extends Model{
    static entity = 'Household\\Model\\Asset';

    static fields() {
        return {
            id: this.attr(null),
            name: this.attr(''),
            value: this.number(''),
            household_id: this.number(null),
            beneficiaryAssignments: this.morphMany(BeneficiaryAssignment, 'assignable_id', 'assignable_type'),
        }
    }
}
